import React from 'react';
import { DSButtonV2 } from '@elliemae/ds-button-v2';
import { Grid } from '@elliemae/ds-grid';
import { DSTypography, TYPOGRAPHY_VARIANTS } from '@elliemae/ds-typography';
import { LifebuoyIcon } from './styled';

const BAND_ANGLES = [45, 135, 225, 315];

// Lifebuoy tip shown in the grid until the first scenario is saved.
export const EmptyScenarios: React.FC<{ onNew: () => void }> = ({ onNew }) => (
  <Grid gutter="xs" justifyItems="center" pt="m">
    <LifebuoyIcon viewBox="0 0 64 64" aria-hidden="true">
      <circle cx="32" cy="32" r="29" />
      <circle cx="32" cy="32" r="14" />
      {BAND_ANGLES.map((angle) => (
        <g key={angle} transform={`rotate(${angle} 32 32)`}>
          <line x1="27" y1="3.4" x2="27" y2="18.9" />
          <line x1="37" y1="3.4" x2="37" y2="18.9" />
        </g>
      ))}
    </LifebuoyIcon>
    <DSTypography variant={TYPOGRAPHY_VARIANTS.H4} color="neutral-600">
      Click on New to Create a New Pricing Scenario
    </DSTypography>
    <DSButtonV2 buttonType="outline" onClick={onNew}>
      New
    </DSButtonV2>
  </Grid>
);

export default EmptyScenarios;
